// UAT environment — frontend on Cloudflare Pages, backend on a small VPS.
// ⚠️ Set `apiBaseUrl` to the real UAT backend URL before the first deploy,
//    e.g. https://api-uat.<your-domain>/api/v1
export const environment = {
  production: true,
  envName: 'uat',
  apiBaseUrl: 'https://api-uat.ggtech24.com/api/v1',
  sentryDsn: '',
  sentryEnv: 'uat',
  pwaEnabled: true,
};
